import { Component, OnInit, Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { RestProvider } from '../environments/rest';
import { DatePipe, JsonPipe } from '@angular/common';



@Injectable()
export class DownloadExcel {
    data = [];
    constructor(public rest: RestProvider,
        private datePipe: DatePipe,) {

    }

    saveFileInSystem1(headers, rows, fileName) {
        this.data = [];
        for (var i = 0; i < rows.length; i++) {
 
                    var tempObj = {}
                    for (let t = 0; t < headers.length; t++) {
                        var key = headers[t]['headers'];
                        tempObj[key] =rows[i]['data'][t]['val'];
                    }
     
                    this.data.push(tempObj)


        }
        this.downloadExcelFile(this.data, fileName);

    }

    saveFileInSystem(object, val) {
        this.data = [];
        if (val == 1) {
            for (var i = 0; i < object.length; i++) {
                this.data.push({
                    Experience: object[i]['experience'],
                    Count: object[i]['count'],
                });
            }

            this.downloadExcelFile(this.data, 'PatientsSeekingCare');
        } else if (val == 2) {
            for (var i = 0; i < object.length; i++) {
                this.data.push({
                    Source: object[i]['source'],
                    'Dropped Requests': object[i]['dropped_requests'],
                    'Total Requests': object[i]['total_requests'],
                });
            }

            this.downloadExcelFile(this.data, 'ConnectcareAccess');
        } else if (val == 3) {
            for (var i = 0; i < object.length; i++) {
                this.data.push({
                    Name: object[i]['name'],
                    Email: object[i]['email'],
                    'Total Consults Completed': object[i]['total_consults_completed'],
                    'Average Delay': object[i]['average_delay'],
                    'Average Duration': object[i]['average_duration'],
                });
            }

            this.downloadExcelFile(this.data, 'ConsultantPerformance');
        } else if (val == 4) {
            for (var i = 0; i < object.length; i++) {
                this.data.push({
                    Source: object[i]['source'],
                    Consults: object[i]['consults'],
                });
            }

            this.downloadExcelFile(this.data, 'ConsultsBySource');
        } else if (val == 5) {
            for (var i = 0; i < object.length; i++) {
                this.data.push({
                    Medium: object[i]['medium'],
                    Consults: object[i]['consults'],
                });
            }

            this.downloadExcelFile(this.data, 'ConsultsByMedium');
        } else if (val == 6) {
            for (var i = 0; i < object.length; i++) {
                this.data.push({
                    Department: object[i]['department'],
                    Consults: object[i]['consults'],
                });
            }

            this.downloadExcelFile(this.data, 'ConsultsByDepartment');
        }
    }

    downloadExcelFile(excelObj, fileName) {
        let sheet = XLSX.utils.json_to_sheet(excelObj);
        let wb = {
            SheetNames: ["export"],
            Sheets: {
                "export": sheet
            }
        };
        let wbout = XLSX.write(wb, {
            bookType: 'xlsx',
            bookSST: false,
            type: 'binary'
        });
        let blob = new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' });

        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
            var base64String = reader.result;

            var a = document.createElement('a');
            a.style.display = 'none';
            a.href = base64String.toString();
            a.download = fileName + '.xlsx';
            document.body.appendChild(a);
            a.click();
        }

    }
    s2ab(s) {
        let buf = new ArrayBuffer(s.length);
        let view = new Uint8Array(buf);
        for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
    savePaymentInfomation(object) {
        this.data = [];
        for (var i = 0; i < object.length; i++) {
            var mrnsInfo = '';
            for (var j = 0; j < object[i]['mrns'].length; j++) {
                mrnsInfo = object[i]['mrns'][j] + ',' + mrnsInfo;
            }
            this.data.push({
                Phone: object[i]['phone'],
                'Booked date': this.getDateInfo(object[i]['booked_date']),
                Id: object[i]['id'],
                Status: object[i]['status'],
                'Order id': object[i]['order_id'],
                'Payment id': object[i]['payment_id'],
                'Consult id': object[i]['consult_id'],
                Start: this.getDateInfo(object[i]['start']),
                'Appointment Status': object[i]['appt_status'],
                Refunded: object[i]['refunded'],
                Name: object[i]['name'],
                Mrns: mrnsInfo,
            });
        }
        this.downloadExcelFile(this.data, 'Payments');
    }
    getDateInfo(date) {
        if (date.length > 0) {
            var jDate = this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
            return this.rest.convertDate(jDate.split(' ')[0]) + ' ' + this.rest.convertTime(jDate.split(' ')[1]);
        }
    }
    saveAppoinmentsExcel(object) {
        
        this.data = [];
        for (var i = 0; i < object.length; i++) {
            var mrnsInfo = '';
            for (var j = 0; j < object[i]['mrns'].length; j++) {
                mrnsInfo = object[i]['mrns'][j] + ',' + mrnsInfo;
            }
            var address = '';
            if (object[i]['geocode'] != null) {
                address = object[i]['geocode']['formatted_address'];
            }

            var logStart;
            var logEnd;
            
            if(object[i]['logs'] != null && object[i]['logs'] != undefined){
                logStart = this.getDateInfo(object[i]['logs']['start']);
                logEnd = this.getDateInfo(object[i]['logs']['end']);
            }

            this.data.push({
                'Patient feedback': object[i]['patient_feedback'],
                Phone: object[i]['phone'],
                Source: object[i]['source'],
                Reason: object[i]['reason'],
                Department: object[i]['department'],
                'Request date': this.getDateInfo(object[i]['request_date']),
                'Appointment start': this.getDateInfo(object[i]['start']),
                'Appointment end': this.getDateInfo(object[i]['end']),
                Status: object[i]['status'],
                'Logs start': logStart,
                'Logs end': logEnd,
                booked_date: this.getDateInfo(object[i]['booked_date']),
                Medium: object[i]['medium'],
                'Consultant name': object[i]['consultant']['name'],
                'Consultant email': object[i]['consultant']['email'],
                'Consultant department': object[i]['consultant']['department'],
                'Advice given': object[i]['advice_given'],
                'Prescription issued': object[i]['prescription_issued'],
                'Advice sent': object[i]['advice_sent'],
                'Consult id': object[i]['consult_id'],
                Name: object[i]['name'],
                Age: object[i]['age'],
                Gender: object[i]['gender'],
                Geocode: address,
                Mrns: mrnsInfo,
                'Consultant feedback': object[i]['consultant_feedback'],
            });
        }
        this.downloadExcelFile(this.data, 'Appointments');
    }
}